import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';
import VueSocketio from 'vue-socket.io';
import socketio from 'socket.io-client';
import VueCookies from 'vue-cookies';
import sockets from './socket';

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import './assets/css/public.css';

import 'vue2-toast/lib/toast.css';
import Toast from 'vue2-toast';
Vue.use(Toast);

import Calendar from 'vue2-datepick';
Vue.use(Calendar);

import Distpicker from 'v-distpicker'
Vue.component('v-distpicker', Distpicker);

import AwesomePicker from 'vue-awesome-picker';
Vue.use(AwesomePicker);

Vue.use(VueCookies);
Vue.use(VueSocketio, socketio('http://appdata.jscx666.cn:8080'), store); //正式环境
//Vue.use(VueSocketio, socketio('http://123.56.214.114:8080'), store); //测试环境
Vue.use(VueAwesomeSwiper);
Vue.config.productionTip = false;

new Vue({
  data() {
    return {
      xxxx: ''
    }
  },
  sockets,
  store,
  router,
  render: h => h(App),
}).$mount('#app');
